<template>
  <div class="box8">
    <div class="box4block" ref="block"></div>
    <div class="box4-top">
      <pageTitle title="采用必修+拓展模式授课<br/>高效就业、灵活提升" />
    </div>
    <div class="box4-title">
      <p>必修课<b> · 打造AI时代运维工程师</b></p>
      <img src="../../../assets/coursePage/java/box4/leg.png" />
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject"
          :key="index"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)" ref="item">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              <span>{{ item.title }}</span>
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            
            <div >
              <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/01.png"
                    alt
                  />课程目标
                </div>
                <div class="main-text">
                  <p v-for="j in item.target" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/03.png"
                    alt
                  />主讲内容
                </div>
                <div class="main-text">
                  <p v-for="j in item.content" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/02.png"
                    alt
                  />项目实战
                </div>
                <div class="main-text main-text2">
                  <p v-for="k in item.project" :key="k">
                    {{ k }}
                  </p>
                </div>
                 <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/04.png"
                    alt
                  />技术架构图
                </div>
                <div class="main-text">
                  <img
                     :src="item.img"
                      @click="openImg(item)"
                    alt
                  />
                </div>
            </div>
          </div>
        </div>
      </div>

      
    </div>
     <div class="box4block2" ref="block2"></div>
    <div class="box4-title" style="margin-top: 0;">
      <p>拓展课<b> · 提升职场竞争力</b></p>
      <a>免费赠送</a>
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in subject2"
          :key="index"
          :style="{
            backgroundColor:
              cur2 == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur2(index)" ref="item2">
            <div class="title">
              <!-- <p v-show="item.stage">{{ item.stage }}</p> -->
              {{ item.title }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur2 == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer2': cur2 == index && showAnswer }"
          >
            <div class="line"></div>
            
            <div >
              <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/01.png"
                    alt
                  />课程目标
                </div>
                <div class="main-text">
                  <p v-for="j in item.target" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/03.png"
                    alt
                  />主讲内容
                </div>
                <div class="main-text">
                  <p v-for="j in item.content" :key="j" v-html="j">
                  
                  </p>
                </div>

                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/02.png"
                    alt
                  />项目实战
                </div>
                <div class="main-text">
                  <p v-for="k in item.project" :key="k">
                    {{ k }}
                  </p>
                </div>
                <div class="title-icon">
                  <img
                    src="../../../assets/coursePage/linux/box8/04.png"
                    alt
                  />技术架构图
                </div>
                <div class="main-text">
                  <img
                    :src="item.img"
                    alt
                    @click="openImg(item)"
                  />
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn" @click="openDetail">查看详细大纲</div> 
    </div>
  
    <div class="previewImage" v-if="isPreview" @click="close">
      <img :src="imgUrl" alt />
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },

  mounted() {},
  data() {
    return {
      tabIndex: 0,
      imgUrl:'',
      isPreview:false,
      subject: [
    {
      "title": "阶段一：云计算运维基础",
      "target": [
        "1. 学员将深入学习Linux系统的安装、部署、文件系统管理、用户管理、权限设置以及使用SSH进行远程管理服务器等核心运维技能。",
        "2. 学员还将掌握系统安全管理，如防火墙和SELinux配置。",
        "3. 学员能够胜任初级系统管理员或初级运维工程师岗位，负责服务器的日常维护、基础配置、项目部署等初级Linux服务器运维工作，带领学生了解整个运维工作流程，引起学生对运维的兴趣。"
      ],
      "content": [
        "1. 运维概述与Linux服务器安装部署",
        "2. 运维工程师必备核心Linux命令",
        "3. 【实战】AI聊天机器人上云实战"
      ],
      "project": [
        "基于阿里云平台的AI大模型对话机器人上线部署"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu01.png")
    },
    {
      "title": "阶段二：系统运维",
      "target": [
        "1. 学员对深入学习Linux系统服务的管理和优化能力，涵盖系统服务的安装与配置、资源监控、进程管理、运维脚本编写、日志分析等。",
        "2. 学员将能够具备处理系统/应用运维中遇到的实际问题，确保服务器稳定高效运行。",
        "3. 学员可以胜任系统运维工程师或应用运维工程师的岗位，专注于系统服务管理、资源管理以及故障处理等工作。"
      ],
      "content": [
        "1. 系统运维基础：Linux网络配置与优化",
        "2. 系统运维核心：Linux系统服务部署与运维",
        "3. 【实战】应用运维实战：Linux环境下的Java智慧养老系统单体部署实现"
      ],
      "project": [
        "Java智慧养老系统脚本运维实战"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu02.png")
    },
    {
      "title": "阶段三：Shell脚本编程",
      "target": [
        "1. 学员能掌握 Shell 核心知识（基础语法、流程结构、函数、正则、三剑客），具备独立编写基础脚本的能力。",
        "2. 学员可运用 Shell 完成 LNMP 搭建、Web 一键部署、“中州养老项目一键部署”，解决运维场景问题，提升自动化效率。",
        "3. 学员能适配运维岗位脚本需求，优化系统管理与故障排查流程，为系统 / 应用运维工作奠定自动化能力基础。"
      ],
      "content": [
        "1. Shell基础语法（变量、环境变量、引号、运算符、编程小工具、判断等）",
        "2. Shell流程结构(While、Until、for、基于LNMP环境实现WEB一键部署)",
        "3. 函数与正则表达式",
        "4. Shell三剑客（grep、sed、awk）",
        "5. Shell脚本编程实战（中州养老一键部署）"
      ],
      "project": [
        "中州智慧养老系统Shell脚本一键部署实战"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu03.png")
    },
    {
      "title": "阶段四：数据库运维",
      "target": [
        "1. 学员将掌握数据库的安装、配置、备份与恢复，以及高可用方案的部署，如主从复制和读写分离。",
        "2. 学员通过实际操作MySQL数据库，将具备确保数据库稳定性和数据安全的能力。",
        "3. 学员可以胜任数据库运维工程师岗位，负责数据库管理、性能优化以及灾备方案的执行。"
      ],
      "content": [
        "1. Java中州智慧养老系统数据库迁移",
        "2. Java中州智慧养老系统数据库配置与调优",
        "3. Java中州智慧养老系统数据库备份与故障恢复",
        "4. Java中州智慧养老系统数据库端冗余架构与主从同步设计",
        "5. Java中州智慧养老系统数据库端读写分离设计",
        "6. Java中州智慧养老系统数据库端MHA高可用及故障转移实战"
      ],
      "project": [
        "Java智慧养老系统数据库运维实战"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu04.png")
    },
    {
      "title": "阶段五：自动化运维",
      "target": [
        "1. 基于NiuShop大型网站系统为背景，实现服务器高可用以及分布式集群搭建。",
        "2. 学员将学习使用Ansible、Jenkins、Prometheus等工具实现自动化部署与自动化运维管理，从而提升运维工作效率。",
        "3. 学员能够胜任自动化运维工程师或DevOps工程师岗位，负责自动化运维体系的建立与优化。"
      ],
      "content": [
        "1. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Nginx单机部署",
        "2. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Nginx分布式环境设计",
        "3. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Ansible配置自动化",
        "4. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Keepalived高可用解决方案",
        "5. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之大流量Nginx/LVS/HAProxy负载均衡实战",
        "6. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Redis分布式数据缓存解决方案",
        "7. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Kafka/RabbitMQ消息队列解决方案",
        "8. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之企业级存储Ceph与MinIO解决方案",
        "9. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之Zabbix/Prometheus企业级监控解决方案",
        "10. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之企业级ELK日志分析解决方案",
        "11. 【实战】大型网站系统NiuShop的自动化运维与高可用架构之CI/CD持续化集成与持续化交付实战",
        "12. 【实战】大型网站系统的自动化运维与高可用架构之系统应用与运维调优"
      ],
      "project": [
        "大型网站系统NiuShop的自动化运维与高可用架构实战"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu05.png")
    },
    {
      "title": "阶段六：容器运维",
      "target": [
        "1. 学员将学习容器化技术的核心技能，掌握Docker和Kubernetes的安装、管理与集群运维，能够实现容器化应用的部署与资源管理。",
        "2. 学员能够胜任容器运维工程师岗位，负责容器化平台的日常维护与优化，支持企业微服务架构的运维需求。"
      ],
      "content": [
        "1. 【实战】基于 Kubernetes的黑马商城项目容器化运维实战之Docker容器化基础",
        "2. 【实战】基于 Kubernetes的容器化微服务架构与运维实战之Containerd容器部署",
        "3. 【实战】基于 Kubernetes的黑马商城项目容器化运维实战之Kubernetes容器编排入门",
        "4. 【实战】基于 Kubernetes的黑马商城项目容器化运维实战之Helm实现包管理与应用部署",
        "5. 【实战】基于 Kubernetes的黑马商城容器化运维实战之Java黑马商城项目微服务部署实践",
        "6. 【实战】基于 Kubernetes的黑马商城项目容器化运维实战之Prometheus容器运维监控",
        "7. 【实战】基于 Kubernetes的黑马商城项目容器化运维实战之EFK日志管理解决方案",
        "8. 【扩展】基于 Kubernetes的黑马商城项目容器化运维实战之PaaS平台集成"
      ],
      "project": [
        "基于Kubernetes的黑马商城容器化运维实战"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu06.png")
    },
    {
      "title": "阶段七：云计算+云安全运维",
      "target": [
        "1. 学员将学习如何部署和管理阿里云的核心服务，包括ECS服务器、SLB负载均衡、OSS存储和CDN加速等。",
        "2. 学员将掌握阿里云监控平台的使用、容器集群的管理（ACK），以及云平台的安全运维配置（如WAF、DDoS防护）。",
        "3. 学员具备云计算资源管理、监控、自动化运维及安全防护的综合能力，能够胜任云计算运维工程师等岗位。"
      ],
      "content": [
        "1. 【实战】云计算运维实战天机学堂之SLB高可用集群部署",
        "2. 【实战】云计算运维实战天机学堂之OSS视频存储与CDN加速解决方案",
        "3. 【实战】云计算运维实战天机学堂之ACK容器化部署实战",
        "4. 【实战】云计算运维实战天机学堂之阿里云监控与自动化运维",
        "5. 【实战】云计算运维实战天机学堂之WAF与DDos防护"
      ],
      "project": [
        "云计算运维实战天机学堂"
      ],
      "img": require("../../../assets/coursePage/linux/box8/bixiu07.png")
    }
  ],
      subject2:[
    {
      "title": "阶段一：Python脚本编程",
      "target": [
        "1. 学员能深入掌握 Python 核心知识，涵盖环境搭建、基础语法（变量、流程控制、数据容器）及 os、psutil、paramiko 等常用运维模块的使用，具备独立编写基础代码的能力。",
        "2. 学员将能够运用 Python 解决运维实际问题，完成服务器监控、日志管理、数据库备份、告警对接等自动化任务，熟练落地 “中州养老系统日志分析与监控告警” 实践。",
        "3. 学员可通过 Python 自动化工具优化运维流程，为从事运维相关工作奠定高效工具开发能力基础。"
      ],
      "content": [
        "1. Python环境搭建",
        "2. Python基本语法（变量、数据类型、运算符、流程控制、数据容器）",
        "3. 常用运维模块如os、sys、re、time、shutil、psutil|requests、paramiko、pymysql等的使用",
        "4. 基于Python实现中州养老系统日志分析与监控告警实践"
      ],
      "project": [
        "中州养老系统日志分析与监控告警"
      ],
      "img": require("../../../assets/coursePage/linux/box8/tuozhan01.png")
    },
    {
      "title": "阶段二：大数据运维",
      "target": [
        "1. 系统掌握大数据运维核心技术栈，涵盖 Hadoop、Hive、Kafka 等平台搭建与运维，精通离线 / 实时开发流程，熟练运用 DolphinScheduler 调度任务，能独立构建稳定高效的大数据处理环境。",
        "2. 通过 “离线平台（开源 / CDH 版）、实时计算、帆软可视化” 等项目实操，掌握从环境部署到业务应用全流程，具备解决复杂大数据场景问题的能力，积累可复用的项目经验。",
        "3. 精准匹配大数据运维岗位需求，理解行业技术应用逻辑（如金融实时计算场景），能够运用所学技术保障平台稳定性、优化数据处理效率，为进入企业从事大数据运维及开发工作筑牢基础。"
      ],
      "content": [
        "1. 大数据运维的定义",
        "2. 大数据开发的方向",
        "3. 离线与实时开发涉及的技术栈",
        "4. 多个平台的搭建（如 Hadoop、Hive、Kafka 等）以及消息队列和任务调度平台",
        "5. 帆软可视化平台搭建"
      ],
      "project": [
        "大数据离线平台环境搭建（开源版）",
        "大数据离线平台环境搭建（CDH商业版本）",
        "实时计算平台搭建",
        "帆软可视化平台搭建"
      ],
      "img": require("../../../assets/coursePage/linux/box8/tuozhan02.png")
    },
    {
      "title": "阶段三：国产信创运维",
      "target": [
        "1. 学员将掌握国产操作系统（如统信UOS、欧拉系统）和国产数据库（如达梦/TiDB/高斯数据库）的运维管理技能。",
        "2. 学员通过操作系统的安装与配置、软件包管理、网络与安全配置、性能优化及资源监控等实战操作，能够确保国产系统的稳定运行。",
        "3. 学员将学习国产数据库的安装、配置、性能调优、高可用集群部署与安全管理等内容。",
        "4. 学员具备在信创环境中执行操作系统和数据库维护、优化及安全管理的能力，能够胜任军工、政府及企事业单位等信创运维岗位。"
      ],
      "content": [
        "1. 【实战】国产信创运维之UOS统信及华为欧拉操作系统运维实战",
        "2. 【实战】国产信创运维之达梦/TiDB/高斯数据库运维实战"
      ],
      "project": [
        "国产信创运维实战之政务办公系统"
      ],
      "img": require("../../../assets/coursePage/linux/box8/tuozhan03.png")
    }
  ] ,
      cur: -1,
      cur2: -1,
      showAnswer: true,
      prevItemHeight: 0,
    };
  },
  methods: {
    openImg(item){
      this.imgUrl=item.img
      this.isPreview = true;
      console.log(item.img)
      
    },
     close() {
      this.isPreview = false;
     
    },
    openDetail() {
      if (localStorage.getItem(`detail-${check.getUrlParam("nid")}`)) {
        window.location.href = localStorage.getItem(
          `detail-${check.getUrlParam("nid")}`
        );
      } else {
        this.clickZiXun()
      }
      this.mai("JavaEE-就业课", "查看详细大纲", 0, null);
    },
    goTop(index) {
      // if( this.showAnswer){
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -this.$refs.item[index].offsetHeight
         
      );
      // }
    },
     goTop2(index) {
      if( this.showAnswer){
      window.scrollTo(
        0,
        this.$refs.item2[index].offsetTop-this.$refs.item2[index].offsetHeight
      );
      }
    },
    changeTabCur(index) {
      this.tabIndex = index;
    },
    changeCur2(index) {
      this.tabIndex = 0;
       this.cur = -1;
     
      const a = document.querySelector(".show-answer2");
      if (a != null && index > this.cur2) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur2) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur2) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur2 = index;
      }
      this.goTop2(index);
    },
    changeCur(index) {
      this.tabIndex = 0;
      this.cur2 = -1;
      
      this.$nextTick(()=>{
        const a = document.querySelector(".show-answer");
        if (a != null && index > this.cur) {
          this.prevItemHeight = a.offsetHeight;
        }
        if (!this.showAnswer || index <= this.cur) {
          this.prevItemHeight = 0;
        }
        if (index == this.cur) {
          this.showAnswer = !this.showAnswer;
        } else {
          this.showAnswer = true;
          this.cur = index;
        }
        this.goTop(index);
      })
      
    },
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
  },
};
</script>

<style lang="less" scoped>
  .previewImage {
    position: fixed;
    top: 0px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 200;
    img {
      width: 100%;
    }
  }
.box8 {
  width: 750px;
 background: linear-gradient( #FFFFFF 0%,#EBF6FF 40%, #EBF6FF 100%);
 padding-bottom:16px;
  .box4block {
    height: 60px;
  }
  .box4block2 {
    height: 1px;
  }
  .box4-top {
    position: relative;
  }
  .box4-title {
    position: relative;
    height: 96px;
    background: linear-gradient(270deg, #72b7fd 0%, #017fff 100%);
    box-shadow: 0px 0px 18px 0px #e2e7f1;
    border-radius: 16px;
    margin: 48px 32px 0;
    display: flex;
    align-items: center;
    p {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #ffffff;
      line-height: 96px;
      text-align: left;
      font-style: normal;
      padding-left: 40px;
      b {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #ffffff;
        line-height: 96px;
        text-align: left;
        display: line-block;
        font-style: normal;
      }
    }
    a {
      width: 180px;
      height: 52px;
      display: block;
      background: #ffffff;
      border-radius: 26px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 30px;
      color: #017fff;
      line-height: 52px;
      text-align: center;
      font-style: normal;
      margin-left: 74px;
    }
    img {
      width: 138px;
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .leftbgc {
    width: 144px;
    height: 178px;
    background: rgba(237, 219, 166, 0.23);
    position: absolute;
    left: 0;
    top: 0;

    filter: blur(50px);
  }
  .rightbgc {
    width: 396px;
    height: 179px;
    background: rgba(166, 192, 237, 0.23);
    right: 0;
    top: 0;
    position: absolute;
    filter: blur(50px);
  }
  .topWrap {
    width: 686px;
    margin: 48px auto 0px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 240px;
      height: 164px;
      background-size: cover;
      margin-right: -18px;
      overflow: hidden;
      margin-bottom: 20px;
      .img {
        width: 48px;
        height: 52px;
        margin: 30px 0 12px 78px;
        background-size: cover;
      }
      p {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 44px;
        margin-left: 78px;
      }
    }
  }
  .box4-btm-box {
    padding-bottom: 64px;
    width: 100%;
    padding-top: 40px;
    // background: linear-gradient(180deg, #ffffff 0%, #f2f6ff 5%, #f2f6ff 100%);
    .box4-btm {
    }
  }

  .btn {
    margin: 0 auto;
    margin-top: 40px;
    width: 480px;
    height: 88px;
   background: linear-gradient( 270deg, #FAAB61 0%, #FB8E51 100%);
border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 30px;
    color: #ffffff;
    line-height: 88px;
    text-align: center;
    font-style: normal;
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
    .subject-box:last-child{margin-bottom: 0;}
  .tab {
    display: flex;
    margin: 20px -12px 40px -12px;
    a {
      display: block;
      padding: 8px 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 26px;
      color: #4e5969;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      margin-right: 12px;
      background: #e4f3ff;
      border-radius: 26px;
    }
    a:last-child {
      margin-right: 0;
    }
    .current {
      background: #0a5bff;
      box-shadow: 0px 8px 16px 0px #b3deff;
      color: #fff;
    }
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: rgba(64, 128, 255, 1);
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 24px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;
    padding: 0px 40px 0px;

    .line {
      margin-bottom: 28px;
      width: 622px;
      height: 1px;
      margin-left: -8px;
      background: #f2f3f5;
    }
  }

  .show-answer,.show-answer2 {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 3200px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 24px;
    display: flex;
    flex-wrap: wrap;
    // margin-left: 45px;
    .block {
      margin-bottom: 16px;
      margin-right: 16px;
      padding: 8px 16px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      background: rgba(106, 161, 255, 0.1);
      border-radius: 10px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }
  }

  .main-text {
    margin-bottom: 40px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
    // margin-left: 45px;
    img{width: 100%;}
    p {
      text-indent: -27px;
      padding-left: 31px;
      // /deep/ i{
      //   margin-left: 31px;
      //    text-indent: -31px;
      //   padding-left: 62px;
      // }
    }
    .three{margin-left: 31px;}
   
  }
   .main-text2{
 p {
      text-indent: 0;
      padding-left: 4px;
      // /deep/ i{
      //   margin-left: 31px;
      //    text-indent: -31px;
      //   padding-left: 62px;
      // }
    }
   }
   p:nth-child(10), p:nth-child(11), p:nth-child(12), p:nth-child(13), p:nth-child(14) {
      text-indent: -40px;
      padding-left: 40px;
    }
  p:nth-child(11) {
    // text-indent: -40px;
    // padding-left: 40px;
    // margin-left: -7px;
  }
  .main-text2 {
    margin-bottom: 16px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 44px;
  }
}
</style>
